import { z } from 'zod';

export const FlashSaleSchema = z.object({
  hasActiveFlashSale: z.boolean().nullish(),
  flashSaleStartDate: z.coerce.date().nullish(),
  flashSaleEndDate: z.coerce.date().nullish(),
  isDailyDeal: z.boolean().nullish(),
});

export type FlashSaleType = z.infer<typeof FlashSaleSchema>;
